import React, { ReactNode, useState } from "react";
import { FichaDeSaudeDoAluno } from "@/AreaRestritta/Components/Saude/Ficha/FichaDeSaudeDoAluno";
import Divider from "antd/es/divider";
import Flex from "antd/es/flex";
import Button from "antd/es/button";
import { Form, Tooltip } from "antd";
import { TypeFichaDeSaude } from "@/Models/Domain/Saude/FIcha/FichaDeSaude";

export const FichaDeSaude: React.FC<{
    codigoDoAluno: number;

    onSucesso?: () => void;
    onCancelar?: () => void;

    txtProximo?: ReactNode;
    txtCancelar?: ReactNode;
}> = (props) => {
    const textoProximo = props.txtProximo ?? "Próximo";
    const textoVoltar = props.txtCancelar ?? "Voltar";

    const [form] = Form.useForm<TypeFichaDeSaude>();

    const [temFicha, setTemFicha] = useState<boolean>(false);

    return (
        <React.Fragment>
            <FichaDeSaudeDoAluno
                codigoDoAluno={props.codigoDoAluno}
                onTemFicha={() => setTemFicha(true)}
                txtAtualizar="Atualizar ficha"
                txtSalvar="Cadastrar nova ficha"
                form={form}
                criarBotaoSubmit={false}
                onSucess={() => props.onSucesso?.()}
            />

            <Divider />

            <Flex justify="start" gap={8}>
                <Button type="primary" danger onClick={() => props.onCancelar?.()}>
                    {textoVoltar}
                </Button>

                <Tooltip title={temFicha ? undefined : <>Para continuar, cadastre uma ficha de saúde para o aluno</>}>
                    <Button type="primary" onClick={() => form.submit()}>
                        {textoProximo}
                    </Button>
                </Tooltip>
            </Flex>
        </React.Fragment>
    );
};
